<template>
	<v-card
		class='speaker-page mt-8'
		style='border-radius: 10px; max-width: 600px;'
		flat
	>
		<v-card-text class='mt-5'>
			<div class='d-flex justify-space-between' style='cursor: pointer;'>
				<div class='page-title d-flex' @click="$router.back()">
					<img
						:src='arrowIcon'
						class='mr-3'
						alt='arrow-icon'
					>
					<span class='text-decoration-underline font-weight-bold'>Back</span>
				</div>
			</div>

			<div
				v-if='!isLoading && !this.isSpeakerEmpty'
			>

				<div class='speaker-page__info mt-8 mb-10'>
					<div class="speaker-page__info-avatar">
						<Avatar
							:avatar='avatarPath'
							size='140px'
							border-radius='square'
							class='user__avatar mr-10'
						/>
					</div>

					<div class='user__brief-description'>
						<h1 class='speaker-page__info-username mb-3'>{{ userName }}</h1>

						<div class='d-flex flex-column'>

							<span
								v-if='companyName'
								class='speaker-page__info-description mb-1'
							>{{ companyName }}</span>

							<span
								v-if='heldPosition'
								class='speaker-page__info-description mb-1'
							>{{ heldPosition }}</span>
						</div>
					</div>
				</div>

				<!-- Speaker sessions -->
				<v-divider class="mb-6"></v-divider>

				<div
					class='user__phone-numbers my-8'
				>
					<h3 class='speaker-page__title mb-3'>Speaker(s) Sessions</h3>

					<v-list>
						<router-link
							:to="{
								name: 'speaker-sessions',
								params: {
									id: speakerId,
									type: 'future'
								}
							}"
							class='d-flex text-decoration-none'
						>
							<v-list-item class='speaker-page__sessions item-without-pseudo mb-3'>
								<div class="d-flex align-center">
									<v-icon class="speaker-page__sessions-icon">mdi-calendar-check-outline</v-icon>
									<span class="speaker-page__sessions-name">Active Sessions</span>
								</div>
								<div class="d-flex align-center ml-2">
									<strong class='speaker-page__sessions-count mr-2'>{{ sessionsCountFuture }}</strong>
									<v-icon class="speaker-page__sessions-chevron">mdi-chevron-right</v-icon>
								</div>
							</v-list-item>
						</router-link>

						<router-link
							:to="{
								name: 'speaker-sessions',
								params: {
									id: speakerId,
									type: 'past'
								}
							}"
							class='d-flex text-decoration-none'
						>
							<v-list-item class='speaker-page__sessions item-without-pseudo'>
								<div class="d-flex align-center">
									<v-icon class="speaker-page__sessions-icon">mdi-calendar-clock-outline</v-icon>
									<span class="speaker-page__sessions-name">Past Sessions</span>
								</div>
								<div class="d-flex align-center ml-2">
									<strong class='speaker-page__sessions-count mr-2'>{{ sessionsCountPast }}</strong>
									<v-icon class="speaker-page__sessions-chevron">mdi-chevron-right</v-icon>
								</div>
							</v-list-item>
						</router-link>
					</v-list>
				</div>
			</div>

			<v-skeleton-loader
				style='width: 100%;'
				v-bind='attrs'
				type='card'
				v-if='this.isLoading || this.isSpeakerEmpty'
			>
			</v-skeleton-loader>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/images/search.svg'
import arrowIcon from '@/assets/images/resourcesIcon/arrow-icon.svg'
import Avatar from '@/components/Avatar'

export default {
	name: 'SpeakerPage',
	components: {
		Avatar,
	},
	computed: {
		...mapGetters('user', ['speaker', 'isLoading']),

		isSpeakerEmpty() {
			const {
				speaker_id: speakerId,
			} = this.speaker || {}

			return speakerId !== +this.$route.params.id
		},

		speakerId() {
			const {
				speaker_id: speakerId,
			} = this.speaker || {}

			return speakerId
		},

		sessionsCountPast() {
			const {
				metaList: {past: {totalCount: pastSessions} = {}} = {},
			} = this.speaker || {}

			return pastSessions || 0;
		},
		sessionsCountFuture() {
			const {
				metaList: {future: {totalCount: futureSessions } = {}} = {},
			} = this.speaker || {}

			return futureSessions || 0;
		},

		userName() {
			const { speaker_name: name } = this.speaker || {}
			return name || ''
		},
		avatarPath() {
			const { speaker_logo: userLogo } = this.speaker || {}
			return userLogo
		},
		heldPosition() {
			const { speaker_title: heldPosition } = this.speaker || {}
			return heldPosition
		},
		companyName() {
			const { speaker_company: company } = this.speaker || {}
			return company
		},

		twitterValue() {
			const { speaker_twitter_url: social = {} } = this.speaker || {}
			return social || ''
		},
		linkedinValue() {
			const { speaker_linked_in: social = {} } = this.speaker || {}
			return social || ''
		}
	},
	methods: {
		...mapActions('user', ['getSpeaker', 'getSpeakerSessions']),

		onTabSwitch() {
			this.successMessage = false
			this.errorMessage = false
		},
		normalizeSettings(item) {
			const { setting, value } = item

			let settings = {}
			settings[setting.name] = value !== '0'

			return settings
		}
	},
	data() {
		return {
			searchIcon,
			arrowIcon,
			successMessage: false,
			errorMessage: false,
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			socialFieldNames: [
				'user_linkedin',
				'user_facebook',
				'user_twitter',
				'user_custom_url',
			],
			phoneFieldNames: [
				'user_work_phone',
				'user_cell_phone',
			],
		}
	},
	created() {
		const speaker = this.speaker
		const id = +this.$route.params.id
		if (id && (speaker && speaker.speaker_id !== id || !speaker)) {
			this.getSpeaker(id)
			if (!speaker || !speaker.sessions || (speaker && speaker.speaker_id !== id))
			this.getSpeakerSessions({ id })
		}
	},
}
</script>

<style lang='scss'>
.v-list-item {
	padding: 0;

	.v-icon {
		margin-right: 12px;
	}
}

.speaker-page {
	font-family: Montserrat, sans-serif;
	padding: 24px 30px 48px 30px;

	@media (max-width: 480px) {
		padding: 12px 15px 24px 15px;
	}

	&__title {
		font-size: 16px;
		font-weight: 700;
		color: var(--accent-color);
		line-height: 19.5px;
	}

	&__sessions {
		padding: 25px 24px 25px 32px !important;
		display: flex;
		justify-content: space-between;
		border-radius: 12px;
		border: 1px solid #E2E2E2;
		background: #FBFBFB;

		&-name {
			font-size: 14px;
			font-weight: 700;
			color: var(--accent-color);
			line-height: 17px;
		}

		&-count {
			font-size: 14px;
			color: #697583;
			line-height: 22px;
		}

		&-icon {
			color: var(--accent-color) !important;
		}
	}

	&__info {
		display: flex;

		&-username {
			font-size: 24px;
			font-weight: 700;
			color: var(--accent-color);
			line-height: 29.3px;
		}

		&-description {
			font-size: 16px;
			color: var(--accent-color);
			line-height: 19.5px;
		}

		@media (max-width: 480px) {
			flex-direction: column;
			align-items: center;
			text-align: center;

			&-avatar {
				padding-left: 40px;
				margin-bottom: 12px;
			}
		}
	}
}

.user {
	&__home-address,
	&__work-address {
		background: rgb(251, 251, 251);
		border-radius: 12px;
		border: 1px solid rgb(226, 226, 226);
	}

	&__brief-description {
		&__location {
			margin-left: -6px;
		}
	}

	&__phone-numbers > ul,
	&__networks > ul {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	@media screen and (max-width: 960px) {

	}
	@media screen and (max-width: 600px) {

	}
}

.item-without-pseudo:after {
	display: none !important;
}
</style>
